export const isShared = window.location.pathname.startsWith("/share/")